export const description = (
  <>
    To log into Justworks, you’ll have to enter a unique verification code after
    entering your password. Set up your preferred delivery method to receive
    codes. Then, select an additional in case you lose access to your first
    choice.
    <br />
    Users in Ireland, Philippines, Singapore, and UAE cannot use "SMS" or "Voice
    call" authentication methods.
    <br />
    <a
      href="https://help.justworks.com/hc/en-us/articles/360004534471-Multi-Factor-Authentication"
      target="_blank"
      rel="noopener noreferrer"
    >
      Learn more about MFA
    </a>
  </>
);

export const title = "Multi-factor authentication (MFA)";
